/** InstallReadinessRoute — skin-aware switcher for /install-readiness. */
import { useUISkin } from "@/data/UISkinContext";
import InstallReadiness from "./InstallReadiness";
import InstallReadinessCockpit from "./InstallReadinessCockpit";

export default function InstallReadinessRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <InstallReadinessCockpit />;
  return <InstallReadiness />;
}
